// src/belediye/services/mesajlasmaApi.js
// Mesajlaşma uçları (10 MD §5 + §9 sözleşmeleri).
//
// KURAL: görünürlük KİMLİKTEN — bu uçlara X-Unit-Slug GÖNDERİLMEZ
// (belediyeApi isNoUnitHeaderEndpoint muafiyeti). Medya için ham /media/
// yolu YOKTUR; indirme yalnız gated download_url üzerindendir.

import api from "./belediyeApi";

// KRİTİK yol düzeltmesi: backend `download_url`'ü "/api/..." KÖK-GÖRELİ verir,
// ama belediyeApi baseURL'i ZATEN ".../api" içerir → api.get("/api/...") çift
// "/api/api/..." üretip 404 döndürür (görsel/dosya HİÇ açılmaz). Baştaki tek
// "/api" atılınca yol baseURL'e göreli olur ve doğru çözülür.
export const toApiRelative = (url) => String(url || "").replace(/^\/api(?=\/|$)/, "");

// Backend SISTEM_EMOJILERI kataloğunun aynası — katalog dışı 400 döner.
export const SISTEM_EMOJILERI = ["👍", "❤️", "😂", "😮", "😢", "🙏", "✅", "👏"];

export const fetchConversations = () =>
  api.get("/mesajlasma/conversations/").then((r) => r.data?.results || []);

// E1 "Sohbeti sil": yalnız KENDİ görünümünden gizle (üyelik/görev korunur;
// yeni mesajda geri açılır). Backend katılımı is_hidden=True yapar.
export const hideConversation = (convId) =>
  api.delete(`/mesajlasma/conversations/${convId}/hide/`).then((r) => r.data);

// FAZ-52: sohbete sonradan ad ver (3 nokta menüsü). Tür ayrımı YOK — kişisel,
// grup, görev, başvuru hepsinde çalışır. Boş string adı siler (başlık türetilmiş
// hâline döner). Ad SOHBETE aittir: herkes aynı adı görür.
export const renameConversation = (convId, title) =>
  api
    .post(`/mesajlasma/conversations/${convId}/rename/`, { title: title ?? "" })
    .then((r) => r.data);

// FAZ-B: grup kurucusu üye çıkarır (yalnız kuran; yalnız grup sohbeti).
export const removeMember = (convId, userId) =>
  api
    .post(`/mesajlasma/conversations/${convId}/members/remove/`, { user_id: userId })
    .then((r) => r.data);

// FAZ-D: birimin AKTİF saha personelini topluca ekle (yalnız kuran; eklenenler
// yalnız eklendikleri ANDAN sonraki mesajları görür). → {count, added:[...]}
export const addSahaPersonel = (convId, unitId) =>
  api
    .post(`/mesajlasma/conversations/${convId}/members/add-saha/`, { unit_id: unitId })
    .then((r) => r.data);

// FAZ-81: sohbete SONRADAN kişi ekle (talep + grup). İzin:
// mesajlasma.participant.add — sohbeti KURMUŞ olmak gerekmez, katılımcı olmak
// yeter. Eklenen kişi, eklendiği andan ÖNCEKİ yazışmayı GÖRMEZ; yalnız olay
// kayıtlarını (talep atandı / onaya gönderildi / onaylandı …) görür.
export const addParticipant = (convId, userId) =>
  api
    .post(`/mesajlasma/conversations/${convId}/participants/`, {
      action: "add",
      user_id: userId,
    })
    .then((r) => r.data);

export const startDirect = (userId) =>
  api
    .post("/mesajlasma/conversations/", { kind: "dogrudan", user_id: userId })
    .then((r) => r.data);

export const startGroup = ({ userIds = [], unitId = null, title = "" }) => {
  const payload = { kind: "grup", user_ids: userIds };
  if (unitId) payload.unit_id = unitId;
  if (title) payload.title = title;
  return api.post("/mesajlasma/conversations/", payload).then((r) => r.data);
};

// GET yanıtı: {conversation_id, kind, title, messages, receipts, typing}
// after_id → yalnız YENİLER (delta poll); before_id → geçmişe sayfalama.
export const fetchMessages = (convId, { afterId, beforeId, limit } = {}) => {
  const params = {};
  if (afterId) params.after_id = afterId;
  if (beforeId) params.before_id = beforeId;
  if (limit) params.limit = limit;
  return api
    .get(`/mesajlasma/conversations/${convId}/messages/`, { params })
    .then((r) => r.data);
};

// FAZ-66: `konum` = {lat, lng} — ataç ▸ "Konum gönder". Verilirse gövde boş
// olabilir (uç "📍 Konum" yazar); ikisi birlikte gider, tek koordinat uçta 400.
export const sendMessage = (convId, body, refApplicationId = null, konum = null) => {
  const payload = { body };
  if (refApplicationId) payload.ref_application_id = refApplicationId;
  if (konum && Number.isFinite(konum.lat) && Number.isFinite(konum.lng)) {
    payload.latitude = konum.lat;
    payload.longitude = konum.lng;
  }
  return api
    .post(`/mesajlasma/conversations/${convId}/messages/`, payload)
    .then((r) => r.data);
};

export const uploadChatFile = (convId, file, body = "") => {
  const fd = new FormData();
  fd.append("file", file);
  if (body) fd.append("body", body);
  return api
    .post(`/mesajlasma/conversations/${convId}/attachments/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// FAZ-55/16 — ÇOKLU DOSYA, TEK MESAJ. Kullanıcı: "üç belge, iki fotoğraf,
// zorunlu mesaj arasında tek tek mesaj olarak gidiyor; bunu istemiyoruz, tek
// bir mesaj olarak gitmesi gerekiyor." Backend aynı uçta getlist("file") okur.
// FAZ-55/19 `messageId`: ekler YENİ mesaj açmak yerine VAR OLAN (kendi, aynı
// sohbetteki) mesaja iliştirilir. Kilitli sohbetten geçen görev akışlarında
// sonuç kartını backend yazdığı için ekler ancak işlemden sonra yüklenebiliyor;
// bu olmadan aynı eylem sohbete iki blok düşürüyordu.
export const uploadChatFiles = (convId, files, body = "", tone = "", messageId = null) => {
  const fd = new FormData();
  (files || []).forEach((f) => fd.append("file", f));
  if (body) fd.append("body", body);
  if (tone) fd.append("tone", tone);
  if (messageId) fd.append("message_id", String(messageId));
  return api
    .post(`/mesajlasma/conversations/${convId}/attachments/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// "Yazıyor…" sinyali — istemci yazarken 3-4 sn'de bir (6 sn TTL backend'de).
export const postTyping = (convId) =>
  api.post(`/mesajlasma/conversations/${convId}/typing/`).catch(() => {});

// Toggle: aynı emoji=kaldır, farklı=değiştir. Yanıt: {reactions:{emoji:{count,me}}}
// FAZ-49: kendi mesajını sil (satır kalır, gövde boşalır — "silindi" izi).
export const deleteMessage = (messageId) =>
  api.delete(`/mesajlasma/messages/${messageId}/`).then((r) => r.data);

export const toggleReaction = (messageId, emoji) =>
  api
    .post(`/mesajlasma/messages/${messageId}/reaction/`, { emoji })
    .then((r) => r.data);

// ÇİFT TİK: bu poll "sistemde" sinyalidir — backend teslim damgası vurur.
export const fetchUnreadTotal = () =>
  api.get("/mesajlasma/unread-count/").then((r) => Number(r.data?.unread) || 0);

// Sohbet başlatma seçicisi: {users:[{id,display_name}], units:[{id,name}]}
// (units yalnız mesajlasma.unit.send sahibine dolu gelir — backend kapısı).
export const searchContacts = (q = "") =>
  api
    .get("/mesajlasma/contacts/", { params: q ? { q } : {} })
    .then((r) => r.data);
